const COMMENTS = [
  {
    id: 1,
    name: '影迷小陈',
    avatar: '陈',
    time: '2 天前',
    content: '向日葵视频真的太方便了！之前每次都要挨个打开香蕉视频、西瓜视频看有什么新片，现在一个页面全搞定了。水果视频在线的分类也很清楚，找片效率高了很多。',
    likes: 128,
  },
  {
    id: 2,
    name: '追剧达人Linda',
    avatar: 'L',
    time: '3 天前',
    content: '从蜜桃视频的甜宠剧入坑的，后来发现樱花视频的动漫专区也很棒。向日葵的每日更新动态让我再也不会错过想追的剧了，编辑推荐也很靠谱。',
    likes: 96,
  },
  {
    id: 3,
    name: '纪录片爱好者老张',
    avatar: '张',
    time: '5 天前',
    content: '植物视频平台的纪录片资源真的很丰富，BBC和国家地理的经典作品都能找到。向日葵视频的导航做得清晰明了，不像其他导航站那么杂乱。',
    likes: 74,
  },
  {
    id: 4,
    name: '学生观影团小美',
    avatar: '美',
    time: '6 天前',
    content: '西瓜视频免费的经典港片合集太香了！学生党没钱充会员，向日葵视频帮我找到了好多免费好资源。水果视频在线平台真的拯救了我的片荒。',
    likes: 63,
  },
  {
    id: 5,
    name: '剧荒克星阿强',
    avatar: '强',
    time: '1 周前',
    content: '向日葵视频的精选专题做得很有水平，不是简单罗列链接，而是真的按照类型和主题整理好了。香蕉视频的动作片合集我刷了三天，推荐给大家！',
    likes: 51,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            用户评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            听听使用向日葵视频的小伙伴们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {COMMENTS.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 text-sm font-bold shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-bold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}